import { createReducer } from '@reduxjs/toolkit';

import { FetchStatus } from '../../enums';
import * as actions from './actions';
import { IAccountState } from './types';

export const initialState: IAccountState = {
  status: {
    account: FetchStatus.IDLE,
    editAccount: FetchStatus.IDLE,
  },
};

export const accountReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(actions.resetAccount, () => initialState)
    .addCase(actions.resetAccountStatus, (state) => {
      state.status.account = FetchStatus.IDLE;
    })
    .addCase(actions.resetEditAccountStatus, (state) => {
      state.status.editAccount = FetchStatus.IDLE;
    })
    .addCase(actions.fetchAccount, (state) => {
      state.status.account = FetchStatus.LOADING;
    })
    .addCase(actions.fetchAccountSucceeded, (state, action) => {
      state.status.account = FetchStatus.SUCCESS;
      state.account = action.payload.account;
    })
    .addCase(actions.fetchAccountFailed, (state) => {
      state.status.account = FetchStatus.FAILURE;
    })
    .addCase(actions.editAccount, (state) => {
      state.status.editAccount = FetchStatus.LOADING;
    })
    .addCase(actions.editAccountSucceeded, (state, action) => {
      state.status.editAccount = FetchStatus.SUCCESS;
      state.account = action.payload.account;
    })
    .addCase(actions.editAccountFailed, (state) => {
      state.status.editAccount = FetchStatus.FAILURE;
    });
});
